import { ReactNode } from 'react'
import { StyleSheetManager } from 'styled-components'

const dataTableLayoutProps = new Set(['grow', 'minWidth', 'maxWidth', 'right'])

export function DataTableStyleSheetManager({ children }: { children: ReactNode }) {
    return (
        <StyleSheetManager
            shouldForwardProp={(prop, target) => {
                if (typeof target !== 'string') return true
                return !dataTableLayoutProps.has(prop)
            }}
        >
            {children}
        </StyleSheetManager>
    )
}
